<template>
    <div>
        <top-navbar></top-navbar>
<div>
 

<div class=" background_color">
  <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/issuetracking/index">
  <span v-if="details && details[1] && details[1].Home">{{ details[1].Home }}</span>
</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/issuetracking/index"><span v-if="details && details[3] && details[3]['Issue Tracking']">{{ details[3]['Issue Tracking'] }}</span> </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> <span v-if="details && details[51] && details[51]['Create Issue Tracking']">{{ details[51]['Create Issue Tracking'] }}</span></h6>
    <div class="container-fluid">
<div class="card bdr-rad2 mt-1 shadow p-2 ">
<div class="card-body">
  <form @submit.prevent="SaveIssue()" enctype="multipart/form-data">

  <b-modal :id="infoModal1.id" 
  :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="sm" hide-footer 
   
  > 
  <template  #modal-title>
     
     <h5 >Message</h5>


   </template>
  <div>
{{infoModal1.content }}
  </div>
 </b-modal>
  <b-modal :id="infoModal2.id" 
  :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="sm" hide-footer
  
  > 
  <template  #modal-title>
     
     <h5 >Message</h5>


   </template>
  <div>
{{infoModal2.content }}
  </div>
 </b-modal>

    <div class="">
  <div class="row">
    <!-- Left Column -->
    <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
      <div class="form-group ">
        <label class="custom-label" style="font-size: small;"> <span v-if="details && details[16] && details[16]['Main Category']">{{ details[16]['Main Category'] }}</span></label>
        <v-select class="font-size_def" v-model="issue.maincat" label="category_name" @input="subCat"  :options="mainscats" :class="{'is-invalid': errors.maincat}"></v-select>
        <div class="invalid-feedback">
              {{ errors.maincat }}
        </div>
        <div v-if="mainLoadding">
          {{ mainmessage }}
        </div>
      </div>

      <div class="form-group ">
        <label class="custom-label" style="font-size: small;">  <span v-if="details && details[17] && details[17]['Sub Category']">{{ details[17]['Sub Category'] }}</span></label>
        <v-select class="font-size_def" v-model="issue.subcat" label="category_name" @input="submessageLoad" :options="subcats" :class="{'is-invalid': errors.subcat}" :disabled="!issue.maincat"></v-select>
        <div class="invalid-feedback">
              {{ errors.subcat }}
        </div>
        <div v-if="subLoadding">
          {{ submessage }}
        </div>
      </div>

      <div class="form-group ">
        <label class="custom-label" style="font-size: small;">  <span v-if="details && details[21] && details[21]['Description']">{{ details[21]['Description'] }}</span></label>
        <textarea class="form-control font-size_def" v-model="issue.description" rows="3"></textarea>
      </div>



      <div class="form-group ">
        <label class="custom-label" style="font-size: small;"><span v-if="details && details[44] && details[44]['Attach Photo']">{{ details[44]['Attach Photo'] }}</span></label>
        <input 
          type="file" 
          class="form-control font-size_def" 
          id="file" 
          name="file" 
          accept="image/*" 
          @change="handleFileChange" 
          :disabled="images.length >= 3" 
          multiple 
        />

<div class="image-preview" v-if="images.length > 0">
  <div v-for="(image, index) in images" :key="index" class="image-container">
    <img :src="image.url" :alt="'Image ' + (index + 1)" class="preview-image" />
    <!-- <button @click="removeImage(index)" class="remove-btn">Remove</button>  -->
  </div>
</div>

<!-- Show an error message if 3 images are already selected -->
<p v-if="images.length === 3" class="info-message">. <span v-if="details && details[89] && details[89]['	You can upload up to 3 images']">{{ details[89]['	You can upload up to 3 images'] }}</span></p>
        
      </div>

      <div class="form-group ">
        <label class="custom-label" style="font-size: small;"> <span v-if="details && details[45] && details[45]['The position of the case']">{{ details[45]['The position of the case'] }}</span></label>
     

    <div class="address-search">
      <input
        class="form-control"
        v-model="searchAddress"
        :placeholder="details && details[91] && details[91]['Search address'] 
                  ? details[91]['Search address'] 
                  : 'Search address'"
        ref="autocomplete"
        autocomplete="off"
        :class="{'is-invalid': errors.searchAddress}"
        @input="handleAddressInput"
        @focus="handleAddressFocus"
        @blur="handleAddressBlur"
        @keydown.down.prevent="highlightNextAddress"
        @keydown.up.prevent="highlightPreviousAddress"
        @keydown.enter.prevent="selectHighlightedAddress"
      />
      <div v-if="addressSearchLoading" class="address-search-dropdown">
        <div class="address-search-status">Searching...</div>
      </div>
      <div v-else-if="showAddressSuggestions && addressSuggestions.length" class="address-search-dropdown">
        <button
          v-for="(suggestion, index) in addressSuggestions"
          :key="suggestion.place_id || suggestion.display_name"
          type="button"
          class="address-search-option"
          :class="{ active: index === highlightedAddressIndex }"
          @mousedown.prevent="selectAddressSuggestion(suggestion)"
        >
          {{ suggestion.display_name }}
        </button>
      </div>
    </div>
    <div class="invalid-feedback">
              {{ errors.searchAddress }}
        </div>
    <input type="hidden" class="form-control" placeholder="Latitude" v-model="issue.lat" />
    <input type="hidden" class="form-control" placeholder="Longitude" v-model="issue.lng" />
      
      </div>

      <div class="form-group ">
        <label class="custom-label" style="font-size: small;"><span v-if="details && details[46] && details[46]['Feedback on the case']">{{ details[46]['Feedback on the case'] }}</span></label>
        <v-select class="font-size_def" label="label" :options="feedback" v-model="issue.feedback" :class="{'is-invalid': errors.feedback}"></v-select>
        <div class="invalid-feedback">
              {{ errors.feedback }}
        </div>
      </div>

      <div class="form-group ">
        <label class="custom-label" style="font-size: small;"> <span v-if="details && details[47] && details[47]['Your contact details']">{{ details[47]['Your contact details'] }}</span></label>
        <input  :placeholder="details && details[49] && details[49]['First name'] 
                ? details[49]['First name'] 
                : 'Default placeholder text'"  v-model="issue.first_name" class="form-control input5 input6 bdr-rad font-size_def " :class="{'is-invalid': errors.first_name}">
        <div class="invalid-feedback">
              {{ errors.first_name }}
        </div>
        <input  :placeholder="details && details[50] && details[50]['Surname'] 
                ? details[50]['Surname'] 
                : 'Default placeholder text'" v-model="issue.surname" class="form-control input5 input6 bdr-rad font-size_def" :class="{'is-invalid': errors.surname}">
        <div class="invalid-feedback">
              {{ errors.surname }}
        </div>
        <input  :placeholder="details && details[89] && details[89]['Email address'] 
                ? details[89]['Email address'] 
                : 'Default placeholder text'"  v-model="issue.email" class="form-control input5 input6 bdr-rad font-size_def" :class="{'is-invalid': errors.email}">
        <div class="invalid-feedback">
              {{ errors.email }}
        </div>
        <input  :placeholder="details && details[90] && details[90]['Mobile number'] 
                ? details[90]['Mobile number'] 
                : 'Default placeholder text'" v-model="issue.mobile" class="form-control input5 input6 bdr-rad font-size_def" :class="{'is-invalid': errors.mobile}">
       <span  style="font-size: small;">(<span v-if="details && details[48] && details[48]['Example']">{{ details[48]['Example'] }}</span> : +46xxxxxxxxx)</span> 
        <div class="invalid-feedback">
              {{ errors.mobile }}
        </div>
      </div>
      <div class="d-grid gap-2">
      <button  type="submit"  style="background-color: #2642a7;color: white;" class="btn btn-sm btn mb-1 font-size_def bdr-rad bdr-rad"  :disabled="loadingdisable"> <span v-if="details && details[52] && details[52]['Create']">{{ details[52]['Create'] }}</span></button>

      
</div>


    </div>

    <!-- Right Column with Map -->
    <div class="col-lg-8 col-md-6 col-sm-12  ">
      <div class="google-map-shell">
    <div id="map" class="google-style-map"></div>
    <div v-if="clickedLocation">
      <!-- <p>Latitude: {{ clickedLocation.lat }}</p>
      <p>Longitude: {{ clickedLocation.lng }}</p> -->
    </div>
  </div>
    </div>
  </div>
</div>

















  
   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
     
    </div>
    <div class="d-flex  ">
     
    </div>
    </div>



</form>
</div>
</div>
</div>
<br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import httpClient from '@/axios';
 import authService from '@/auth.service';
 import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'
  import vSelect from 'vue-select'

  const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || '';
  const GOOGLE_MAPS_CALLBACK = '__issueTrackingGoogleMapsLoaded';
  const LEAFLET_CSS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  const LEAFLET_JS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  const LEAFLET_IMAGE_BASE_URL = 'https://unpkg.com/leaflet@1.9.4/dist/images/';

  export default {
   

    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        file: null,
        issue:{},
        issue_det:[],
        aprts:[],
        errors: {},
        mainLoadding:false,
        mainmessage:'',
        subLoadding:false,
        submessage:'',
        searchAddress: '',
        searchAddressTimer: null,
        addressSuggestions: [],
        addressSearchLoading: false,
        showAddressSuggestions: false,
        highlightedAddressIndex: -1,
        mainscats:[],
        subcats:[],
        repots:[],
        file_atach:{},
        loadingdisable: false,
        images: [],
        details: [],
        feedback:[
        { label: 'Feedback via e-mail', value: 'Email' },
        { label: 'Feedback via SMS', value: 'SMS' },
        ],
        marker: null,
        map: null,
        mapProvider: '',
        leafletMap: null,
        leafletMarker: null,
        clickedLocation: null,
      
        geocoder: null, 
        autocomplete: null, // To handle address autocomplete
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
        infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },

        // variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        // headerBgVariant: 'mycoolor',
        // headerTextVariant: 'light',
        
      }

    },
    mounted(){
      this.initializePage();
    },
methods : {

  async initializePage() {
    await Promise.all([
      this.loadlanguage(),
      this.loadCat(),
    ]);

    await this.$nextTick();
    await this.initializeLeafletMap();
  },

  isGoogleMapsReady() {
    return typeof window !== 'undefined' &&
      window.google &&
      window.google.maps &&
      window.google.maps.places;
  },

  loadGoogleMaps() {
    if (this.isGoogleMapsReady()) {
      return Promise.resolve();
    }

    if (window.issueTrackingGoogleMapsPromise) {
      return window.issueTrackingGoogleMapsPromise;
    }

    window.issueTrackingGoogleMapsPromise = new Promise((resolve, reject) => {
      let settled = false;
      const timeout = setTimeout(() => {
        rejectLoad(new Error('Google Maps script timed out'));
      }, 8000);

      const resolveWhenReady = () => {
        if (settled) {
          return;
        }

        if (this.isGoogleMapsReady()) {
          settled = true;
          clearTimeout(timeout);
          resolve();
          return;
        }

        setTimeout(resolveWhenReady, 100);
      };

      const rejectLoad = (error) => {
        if (settled) {
          return;
        }

        settled = true;
        clearTimeout(timeout);
        reject(error || new Error('Google Maps script failed to load'));
      };
      const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      window.gm_authFailure = () => {
        rejectLoad(new Error('Google Maps authentication failed'));
        this.initializeLeafletMap();
      };

      if (existingScript) {
        existingScript.addEventListener('load', resolveWhenReady, { once: true });
        existingScript.addEventListener('error', () => rejectLoad(), { once: true });
        resolveWhenReady();
        return;
      }

      window[GOOGLE_MAPS_CALLBACK] = resolveWhenReady;

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&callback=${GOOGLE_MAPS_CALLBACK}&v=weekly`;
      script.async = true;
      script.defer = true;
      script.onerror = () => rejectLoad();
      document.head.appendChild(script);
    });

    return window.issueTrackingGoogleMapsPromise;
  },

  loadLeaflet() {
    if (window.L) {
      return Promise.resolve(window.L);
    }

    if (window.issueTrackingLeafletPromise) {
      return window.issueTrackingLeafletPromise;
    }

    window.issueTrackingLeafletPromise = new Promise((resolve, reject) => {
      if (!document.querySelector(`link[href="${LEAFLET_CSS_URL}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = LEAFLET_CSS_URL;
        document.head.appendChild(link);
      }

      const existingScript = document.querySelector(`script[src="${LEAFLET_JS_URL}"]`);
      const configureLeaflet = () => {
        if (!window.L) {
          reject(new Error('Leaflet did not initialize'));
          return;
        }

        delete window.L.Icon.Default.prototype._getIconUrl;
        window.L.Icon.Default.mergeOptions({
          iconRetinaUrl: `${LEAFLET_IMAGE_BASE_URL}marker-icon-2x.png`,
          iconUrl: `${LEAFLET_IMAGE_BASE_URL}marker-icon.png`,
          shadowUrl: `${LEAFLET_IMAGE_BASE_URL}marker-shadow.png`,
        });

        resolve(window.L);
      };

      if (existingScript) {
        existingScript.addEventListener('load', configureLeaflet, { once: true });
        existingScript.addEventListener('error', () => reject(new Error('Leaflet script failed to load')), { once: true });
        if (window.L) {
          configureLeaflet();
        }
        return;
      }

      const script = document.createElement('script');
      script.src = LEAFLET_JS_URL;
      script.defer = true;
      script.onload = configureLeaflet;
      script.onerror = () => reject(new Error('Leaflet script failed to load'));
      document.head.appendChild(script);
    });

    return window.issueTrackingLeafletPromise;
  },

  validate(){
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // const mobilePattern = /^\+46\d{2}\d{3}\d{4}$/; 
    // const mobilePattern = /^(?:\+47\d{8}|0\d{9})$/;
   // const mobilePattern = /^(?:\+46|0)\d{9}$/;
    // const mobilePattern = /^(?:\+46|0)([ -]?\d){9}$/;
      this.errors = {};
      if(this.issue.maincat == null){
        this.$set(this.errors, 'maincat', "Main Category field is required");
      }
      if(this.issue.subcat == null){
        this.$set(this.errors, 'subcat', "Sub Category field is required");
      }
      if(!this.searchAddress || !this.issue.lat || !this.issue.lng){
        this.$set(this.errors, 'searchAddress', "The position of the case is required");
      }
      if(this.issue.subcat == null){
        this.$set(this.errors, 'subcat', "Sub Category field is required");
      }
      if(this.issue.feedback == null){
        this.$set(this.errors, 'feedback', "Feedback on the case field is required");
      }
      // if(this.issue.first_name == null){
      //   this.$set(this.errors, 'first_name', "First name is required");
      // }
      // if(this.issue.surname == null){
      //   this.$set(this.errors, 'surname', "Surename is required");
      // }
      if (!emailPattern.test(this.issue.email)) {
        this.$set(this.errors, 'email', "Please enter a valid email address");
      }
    
      if (!this.issue.mobile) {
        this.$set(this.errors, 'mobile', "Mobile number is required");
    } else {
        try {
          const phoneNumber = libphonenumber.parsePhoneNumber(this.issue.mobile, 'SE'); // 'SE' for Sweden

// Validate number and prefix
if (phoneNumber.isValid() && phoneNumber.country === 'SE') {
  const validPrefixes = ['4670', '4671', '4672', '4673', '4676', '4679'];
  const prefix = phoneNumber.number.slice(1, 5); // Extract "+467x"

  if (!validPrefixes.includes(prefix)) {
    addError('mobile', "Invalid Swedish mobile number.");
  }
} else {
  addError('mobile', "Please enter a valid mobile number");
}
        } catch (error) {
            this.$set(this.errors, 'mobile', "Please enter a valid mobile number");
        }
    }
      // if(this.squatation.customer_contact == null){
      //   this.$set(this.errors, 'customerContactError', "Customer Contact field is required");
      // }
      // if(this.sales == null){
      //   this.$set(this.errors, 'salespeoplesError', "Sales Person field is required");
      // }
      // if(this.quotation.id_brand == null){
      //   this.$set(this.errors, 'idbrandError', "Brand field is required");
      // }
     },


     initializeMap() {
  if (!this.isGoogleMapsReady()) {
    console.error("Google Maps is not ready");
    return;
  }

  const defaultLocation = { lat: 59.3287, lng: 18.2507 }; // Default location (Sweden)
  const swedenBounds = this.getSwedenBounds();
  const mapDiv = document.getElementById("map");

  if (!mapDiv) {
    console.error("Map div not found");
    return;
  }

  if (this.leafletMap) {
    this.leafletMap.remove();
    this.leafletMap = null;
    mapDiv.innerHTML = '';
  }

  this.mapProvider = 'google';
  this.map = new google.maps.Map(mapDiv, {
    center: defaultLocation,
    zoom: 12,
    restriction: {
      latLngBounds: swedenBounds,
      strictBounds: false,
    },
  });

  this.geocoder = new google.maps.Geocoder();

  const input = this.$refs.autocomplete;
  if (input) {
    this.autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'se' },
    });
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
  }

  this.map.addListener("click", (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    const clickedLocation = new google.maps.LatLng(lat, lng);

    if (swedenBounds.contains(clickedLocation)) {
      this.updateMarker(lat, lng);
      this.reverseGeocode(lat, lng);
    } else {
      alert("Selected location is outside of Sweden.");
    }
  });

  this.addIssueMarkers(swedenBounds);
},

getSwedenBounds() {
  return new google.maps.LatLngBounds(
    new google.maps.LatLng(55.005, 11.0274),
    new google.maps.LatLng(69.1062, 24.1553)
  );
},

getDetail(index, key, fallback) {
  const value = this.details && this.details[index] && this.details[index][key];
  return value === undefined || value === null ? fallback : value;
},

getIssueStatusHtml(issue) {
  if (issue.statusvalue === 1) {
    return `<span style="color:red;">${issue.status}</span>`;
  } else if (issue.statusvalue === 42) {
    return `<span style="color:#ee68f9;">${issue.status}</span>`;
  } else if (issue.statusvalue === 49 || issue.statusvalue === 21) {
    return `<span style="color:green;">${issue.status}</span>`;
  } else if (issue.statusvalue === 51) {
    return `<span style="color:#f8a081;">${issue.status}</span>`;
  }

  return issue.status || '';
},

getIssueInfoWindowContent(issue) {
  if(issue.statusvalue === 52){
    return `
  <div>
    <h5 style="color:#007bff;"> ${issue.tiketnum}</h5>
   
  <span style="font-size:14px;"><b>
     ${issue.address}.<br>
   
  </span>
  </div>
`;
  }

  return `
  <div>
    <h5 style="color:#007bff;">${this.getDetail(138, 'Case', 'Case')} ${issue.tiketnum}</h5>
   
  <span style="font-size:14px;"><b>
     ${issue.address}.<br>
    <strong>${this.getDetail(124, 'Ticket', 'Ticket')} #:</strong> ${issue.tiketnum}<br>
    <strong>${this.getDetail(139, 'Category', 'Category')}:</strong> ${issue.maincat}<br>
    <strong>${this.getDetail(17, 'Sub Category', 'Sub Category')}:</strong> ${issue.msubcat}<br><br>
    <strong>${this.getDetail(22, 'Status', 'Status')}:</strong><b> ${this.getIssueStatusHtml(issue)}</b><br></b>
  </span>
  </div>
`;
},

addIssueMarkers(swedenBounds) {
  const issues = Array.isArray(this.issue_det) ? this.issue_det : [];

  issues.forEach((issue) => {
    const lat = parseFloat(issue.latitude);
    const lng = parseFloat(issue.longitude);

    if (isNaN(lat) || isNaN(lng)) {
      return;
    }

    const position = { lat, lng };

    if (!swedenBounds.contains(position)) {
      console.warn(`Issue ID ${issue.id} is outside Sweden and won't be displayed.`);
      return;
    }

    const marker = new google.maps.Marker({
      position,
      map: this.map,
    });

    const infoWindow = new google.maps.InfoWindow({
      content: this.getIssueInfoWindowContent(issue),
    });

    marker.addListener("mouseover", () => {
      infoWindow.open(this.map, marker);
    });

    marker.addListener("mouseout", () => {
      infoWindow.close();
    });

    marker.addListener("click", () => {
      this.issue.lat = lat;
      this.issue.lng = lng;
      this.searchAddress = issue.address || '';
    });
  });
},

getLeafletRedIcon() {
  return window.L.divIcon({
    className: 'leaflet-red-marker-icon',
    html: '<span class="leaflet-red-marker"></span>',
    iconSize: [30, 42],
    iconAnchor: [15, 42],
    popupAnchor: [0, -38],
  });
},

async initializeLeafletMap() {
  try {
    await this.loadLeaflet();
  } catch (error) {
    console.error('Leaflet failed to load', error);
    return;
  }

  const L = window.L;
  const defaultLocation = [59.3287, 18.2507];
  const swedenBounds = L.latLngBounds(
    [55.005, 11.0274],
    [69.1062, 24.1553]
  );
  const mapDiv = document.getElementById("map");

  if (!mapDiv) {
    console.error("Map div not found");
    return;
  }

  if (this.leafletMap) {
    this.leafletMap.remove();
    this.leafletMap = null;
  }

  mapDiv.innerHTML = '';
  if (mapDiv._leaflet_id) {
    mapDiv._leaflet_id = null;
  }

  this.mapProvider = 'leaflet';
  this.map = null;
  this.marker = null;
  this.leafletMarker = null;
  this.geocoder = null;
  this.autocomplete = null;

  this.leafletMap = L.map(mapDiv, {
    attributionControl: false,
    maxBounds: swedenBounds,
    maxBoundsViscosity: 0.8,
    zoomControl: false,
  }).setView(defaultLocation, 12);

  L.control.attribution({
    position: 'bottomright',
    prefix: false,
  }).addTo(this.leafletMap);

  const roadLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
    attribution: '&copy; OpenStreetMap contributors &copy; CARTO',
    maxZoom: 20,
    subdomains: 'abcd',
  });
  const satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri',
    maxZoom: 19,
  });

  roadLayer.addTo(this.leafletMap);

  L.control.layers({
    Map: roadLayer,
    Satellite: satelliteLayer,
  }, null, {
    collapsed: false,
    position: 'bottomleft',
  }).addTo(this.leafletMap);

  L.control.zoom({
    position: 'bottomright',
  }).addTo(this.leafletMap);

  this.leafletMap.on('click', (event) => {
    const lat = event.latlng.lat;
    const lng = event.latlng.lng;

    if (!this.isWithinSweden(lat, lng)) {
      alert("Selected location is outside of Sweden.");
      return;
    }

    this.updateLeafletMarker(lat, lng);
    this.reverseGeocodeWithOpenStreetMap(lat, lng);
  });

  this.addLeafletIssueMarkers();
},

isWithinSweden(lat, lng) {
  return lat >= 55.005 && lat <= 69.1062 && lng >= 11.0274 && lng <= 24.1553;
},

addLeafletIssueMarkers() {
  const L = window.L;
  const issues = Array.isArray(this.issue_det) ? this.issue_det : [];

  issues.forEach((issue) => {
    const lat = parseFloat(issue.latitude);
    const lng = parseFloat(issue.longitude);

    if (isNaN(lat) || isNaN(lng) || !this.isWithinSweden(lat, lng)) {
      return;
    }

    const marker = L.marker([lat, lng], {
      icon: this.getLeafletRedIcon(),
    })
      .addTo(this.leafletMap)
      .bindPopup(this.getIssueInfoWindowContent(issue));

    marker.on('mouseover', () => marker.openPopup());
    marker.on('mouseout', () => marker.closePopup());
    marker.on('click', () => {
      this.issue.lat = lat;
      this.issue.lng = lng;
      this.searchAddress = issue.address || '';
    });
  });
},

updateLeafletMarker(lat, lng) {
  const L = window.L;
  const position = [lat, lng];

  if (this.leafletMarker) {
    this.leafletMarker.setLatLng(position);
  } else {
    this.leafletMarker = L.marker(position, {
      icon: this.getLeafletRedIcon(),
    }).addTo(this.leafletMap);
  }

  this.leafletMap.setView(position, Math.max(this.leafletMap.getZoom(), 13));
  this.issue.lat = lat;
  this.issue.lng = lng;
},

async reverseGeocodeWithOpenStreetMap(lat, lng) {
  try {
    const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lng)}&accept-language=en`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('OpenStreetMap reverse geocoding failed');
    }

    const data = await response.json();
    this.searchAddress = data.display_name || `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
  } catch (error) {
    console.error(error);
    this.searchAddress = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
  }
},

handleAddressInput() {
  clearTimeout(this.searchAddressTimer);
  this.issue.lat = null;
  this.issue.lng = null;

  const address = this.searchAddress ? this.searchAddress.trim() : '';

  if (address.length < 3) {
    this.addressSuggestions = [];
    this.showAddressSuggestions = false;
    this.addressSearchLoading = false;
    return;
  }

  this.showAddressSuggestions = true;
  this.searchAddressTimer = setTimeout(() => {
    this.fetchAddressSuggestions(address);
  }, 800);
},

handleAddressFocus() {
  if (this.addressSuggestions.length) {
    this.showAddressSuggestions = true;
  }
},

handleAddressBlur() {
  setTimeout(() => {
    this.showAddressSuggestions = false;
  }, 200);
},

highlightNextAddress() {
  if (!this.addressSuggestions.length) {
    return;
  }

  this.showAddressSuggestions = true;
  this.highlightedAddressIndex = (this.highlightedAddressIndex + 1) % this.addressSuggestions.length;
},

highlightPreviousAddress() {
  if (!this.addressSuggestions.length) {
    return;
  }

  this.showAddressSuggestions = true;
  this.highlightedAddressIndex = this.highlightedAddressIndex <= 0
    ? this.addressSuggestions.length - 1
    : this.highlightedAddressIndex - 1;
},

async selectHighlightedAddress() {
  if (this.addressSuggestions.length) {
    const index = this.highlightedAddressIndex >= 0 ? this.highlightedAddressIndex : 0;
    this.selectAddressSuggestion(this.addressSuggestions[index]);
    return;
  }

  await this.searchAddressLocation();
},

async searchAddressLocation() {
  clearTimeout(this.searchAddressTimer);

  const address = this.searchAddress ? this.searchAddress.trim() : '';

  if (!address || address.length < 3) {
    return;
  }

  if (this.addressSuggestions.length) {
    this.selectAddressSuggestion(this.addressSuggestions[0]);
    return;
  }

  await this.fetchAddressSuggestions(address);

  if (this.addressSuggestions.length) {
    this.selectAddressSuggestion(this.addressSuggestions[0]);
  } else if (this.mapProvider === 'google' && this.geocoder) {
    this.searchGoogleAddress(address);
  } else {
    alert('No location found for this address.');
  }
},

searchGoogleAddress(address) {
  this.geocoder.geocode({
    address,
    componentRestrictions: { country: 'SE' },
  }, (results, status) => {
    if (status !== 'OK' || !results[0] || !results[0].geometry) {
      alert('No location found for this address.');
      return;
    }

    const location = results[0].geometry.location;
    const swedenBounds = this.getSwedenBounds();

    if (!swedenBounds.contains(location)) {
      alert('Selected place is outside of Sweden.');
      return;
    }

    this.searchAddress = results[0].formatted_address || address;
    this.updateMap(location);
  });
},

async fetchAddressSuggestions(address) {
  this.addressSearchLoading = true;

  try {
    const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&addressdetails=1&countrycodes=se&limit=6&q=${encodeURIComponent(address)}`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('OpenStreetMap search failed');
    }

    const results = await response.json();
    const currentAddress = this.searchAddress ? this.searchAddress.trim() : '';

    if (currentAddress !== address) {
      return;
    }

    this.addressSuggestions = results.filter((result) => {
      const lat = parseFloat(result.lat);
      const lng = parseFloat(result.lon);

      return !isNaN(lat) && !isNaN(lng) && this.isWithinSweden(lat, lng);
    });

    this.highlightedAddressIndex = this.addressSuggestions.length ? 0 : -1;
    this.showAddressSuggestions = this.addressSuggestions.length > 0;
  } catch (error) {
    console.error(error);
    this.addressSuggestions = [];
    this.highlightedAddressIndex = -1;
  } finally {
    this.addressSearchLoading = false;
  }
},

selectAddressSuggestion(suggestion) {
  if (!suggestion) {
    return;
  }

  const lat = parseFloat(suggestion.lat);
  const lng = parseFloat(suggestion.lon);

  if (isNaN(lat) || isNaN(lng) || !this.isWithinSweden(lat, lng)) {
    alert('Selected place is outside of Sweden.');
    return;
  }

  this.searchAddress = suggestion.display_name;
  this.addressSuggestions = [];
  this.showAddressSuggestions = false;
  this.highlightedAddressIndex = -1;
  this.applyAddressLocation(lat, lng);
},

applyAddressLocation(lat, lng) {
  if (this.mapProvider === 'google' && this.map && window.google) {
    this.updateMap(new google.maps.LatLng(lat, lng));
    return;
  }

  if (this.mapProvider === 'leaflet' && this.leafletMap) {
    this.updateLeafletMarker(lat, lng);
    return;
  }

  this.issue.lat = lat;
  this.issue.lng = lng;
},

// Handle place selection from the dropdown
handlePlaceSelect() {
  if (!this.autocomplete) {
    return;
  }

  const place = this.autocomplete.getPlace();
  if (!place.geometry) {
    alert("No geometry found for this place");
    return;
  }

  // Get the location's latitude and longitude
  const location = place.geometry.location;
  const lat = location.lat();
  const lng = location.lng();

  // Check if the selected place is within Sweden
  const swedenBounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(55.005, 11.0274), // Southwest corner of Sweden
    new google.maps.LatLng(69.1062, 24.1553)  // Northeast corner of Sweden
  );

  if (swedenBounds.contains(location)) {
    // Update lat/lng fields
    this.issue.lat = lat;
    this.issue.lng = lng;

    // Populate search input with formatted address
    this.searchAddress = place.formatted_address;

    // Update map and marker
    this.updateMap(location);
  } else {
    alert('Selected place is outside of Sweden.');
  }
},

// Update map, lat/lng fields, and place marker
updateMap(location) {
  if (!this.map) {
    return;
  }

  this.map.setCenter(location);

  const lat = location.lat();
  const lng = location.lng();

  // Update lat/lng fields
  this.issue.lat = lat;
  this.issue.lng = lng;

  // Update marker position
  this.updateMarker(lat, lng);
},

// Place or move the marker on the map
updateMarker(lat, lng) {
  if (this.mapProvider === 'leaflet') {
    this.updateLeafletMarker(lat, lng);
    return;
  }

  if (!this.map) {
    return;
  }

  const position = { lat, lng };

  if (this.marker) {
    this.marker.setPosition(position);
  } else {
    this.marker = new google.maps.Marker({
      position,
      map: this.map,
    });
  }

  // Update lat/lng in inputs
  this.issue.lat = lat;
  this.issue.lng = lng;
},

// Reverse geocode lat/lng to get address and set it to the input
reverseGeocode(lat, lng) {
  if (!this.geocoder) {
    this.reverseGeocodeWithOpenStreetMap(lat, lng);
    return;
  }

  const latlng = { lat, lng };
  this.geocoder.geocode({ location: latlng }, (results, status) => {
    if (status === 'OK' && results[0]) {
      // Check if the result is within Sweden
      const swedenBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(55.005, 11.0274), // Southwest corner of Sweden
        new google.maps.LatLng(69.1062, 24.1553)  // Northeast corner of Sweden
      );

      const resultLocation = results[0].geometry.location;
      if (swedenBounds.contains(resultLocation)) {
        // Populate the search box with the formatted address
        this.searchAddress = results[0].formatted_address;
      } else {
        alert('Geocoded address is outside of Sweden.');
      }
    } else {
      alert('Geocoder failed: ' + status);
    }
  });
},


    

    handleFileChange(event) {
  const files = event.target.files; // Get all selected files
  if (!files.length) return; // Return if no files are selected

  // Limit the number of images to 3
  if (this.images.length + files.length > 3) {
    alert('You can only upload up to 3 images.');
    return;
  }

  // Loop through the selected files and read each one
  Array.from(files).forEach((file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      // Push the image and its URL to the images array
      this.images.push({ name: file.name, url: e.target.result, file }); // Keep the file object for upload
    };
    reader.readAsDataURL(file); // Read the image as a data URL for preview
  });

  // Reset the file input value so the same image can be selected again if needed
  event.target.value = null;
},







  async SaveIssue() {
   
 this.validate();
  

  
    if(Object.keys(this.errors).length === 0){

      this.loadingdisable = true;
  
  const formData = new FormData();
  
  // Append each image file to FormData
  this.images.forEach((image, index) => {
    formData.append(`file${index + 1}`, image.file); // Use file1, file2, file3 as keys
     // Access the file property
  });
  
  // Append additional data to FormData
  formData.append("userid", this.userid);
  formData.append("issue", JSON.stringify(this.issue));
  formData.append("searchAddress", JSON.stringify(this.searchAddress));
   
   
      try {
      const { data} = await  httpClient.post('/web/api/issuetracking/create',formData,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          // 'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.status = data.status;
       if(this.status == 200){
        alert("Thank You");
        window.location.reload();
       }
      
    } catch (error) {
      console.log(error.response);
    }
   
    
  }
  },


  async loadCat() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/loadcat',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.mainscats = data.mainscats;
       this.issue_det = data.issue_det;
     
       
      
    } catch (error) {
      console.log(error.response);
    }
  },

  async loadlanguage() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  httpClient.get('/web/api/user/loadlanguage',{
        headers:{
          // 'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.details = data.details;
      
       console.log(this.details);
       
      
    } catch (error) {
      console.log(error.response);
    }
  },

  async submessageLoad() {
    
    console.log(this.issue.subcat.message_status);
     if(this.issue.subcat.message_status == 1){
      this.infoModal2.content =  this.issue.subcat.message
      this.$root.$emit('bv::show::modal', this.infoModal1.id);
     }


    },


  async subCat() {
    // console.log("aaaaa");
    // console.log(this.issue.maincat);
    if(this.issue.maincat == null){
        this.issue.subcat = '';
    }
     if(this.issue.maincat.message_status == 1){

      this.infoModal1.content =  this.issue.maincat.message;
      this.$root.$emit('bv::show::modal', this.infoModal1.id);
     
     }
   
    try {
      const { data} = await  httpClient.post('/web/api/issuetracking/loadsub',{userid:this.userid,issue:this.issue},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       
       this.subcats = data.subcats;
       
      
    } catch (error) {
      console.log(error.response);
    }
  },

      
    



  
 

 


 





  
  
  


},

    components :{
        ContentFooter,
        TopNavbar,
        'v-select': vSelect,
    },
  }

</script>
<style >
.gm-ui-hover-effect {
  display: none !important;
}
/* .modal .modal-content {
margin-top: 20% !important;
} */

.image-preview {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.preview-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.error-message {
  color: red;
  margin-top: 10px;
}

.google-map-shell {
  position: relative;
  height: 600px;
  overflow: hidden;
  background: #e5e3df;
  border: 1px solid #d9dce1;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.24), 0 2px 6px rgba(60, 64, 67, 0.16);
}

.google-style-map {
  width: 100%;
  height: 100%;
  font-family: Roboto, Arial, sans-serif;
  background: #e5e3df;
}

.google-style-map .leaflet-tile-pane {
  filter: saturate(1.06) contrast(0.98) brightness(1.02);
}

.google-style-map .leaflet-control-container {
  font-family: Roboto, Arial, sans-serif;
}

.google-style-map .leaflet-control-zoom,
.google-style-map .leaflet-control-layers,
.google-style-map .leaflet-popup-content-wrapper {
  border: 0;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(60, 64, 67, 0.3);
}

.google-style-map .leaflet-control-zoom {
  margin-right: 12px;
  margin-bottom: 34px;
  overflow: hidden;
}

.google-style-map .leaflet-control-zoom a {
  width: 40px;
  height: 40px;
  color: #3c4043;
  font-size: 24px;
  font-weight: 400;
  line-height: 40px;
  background: #fff;
  border: 0;
  border-bottom: 1px solid #e8eaed;
}

.google-style-map .leaflet-control-zoom a:last-child {
  border-bottom: 0;
}

.google-style-map .leaflet-control-zoom a:hover {
  color: #202124;
  background: #f8f9fa;
}

.google-style-map .leaflet-control-layers {
  margin-bottom: 16px;
  margin-left: 12px;
  padding: 0;
  color: #202124;
  background: #fff;
}

.google-style-map .leaflet-control-layers-list,
.google-style-map .leaflet-control-layers-base {
  display: flex;
}

.google-style-map .leaflet-control-layers label {
  min-width: 86px;
  margin: 0;
  padding: 8px 11px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  cursor: pointer;
  border-right: 1px solid #e8eaed;
}

.google-style-map .leaflet-control-layers label:last-child {
  border-right: 0;
}

.google-style-map .leaflet-control-layers-selector {
  width: 13px;
  height: 13px;
  margin: 0 5px 0 0;
  vertical-align: -2px;
  accent-color: #1a73e8;
}

.google-style-map .leaflet-control-attribution {
  margin-right: 8px;
  margin-bottom: 6px;
  padding: 2px 6px;
  color: #5f6368;
  font-size: 11px;
  line-height: 1.2;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 2px;
}

.google-style-map .leaflet-control-attribution a {
  color: #3c4043;
}

.google-style-map .leaflet-popup-content-wrapper {
  color: #202124;
}

.google-style-map .leaflet-popup-content {
  margin: 12px 14px;
  font-size: 13px;
}

.address-search {
  position: relative;
}

.address-search-dropdown {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  z-index: 2000;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #d8dde6;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.14);
}

.address-search-option,
.address-search-status {
  display: block;
  width: 100%;
  padding: 8px 10px;
  font-size: 13px;
  line-height: 1.3;
  color: #1f2933;
  text-align: left;
  background: #fff;
  border: 0;
  border-bottom: 1px solid #eef1f5;
}

.address-search-option:hover,
.address-search-option.active {
  background: #edf3ff;
}

.address-search-option:last-child {
  border-bottom: 0;
}

.leaflet-red-marker-icon {
  background: transparent;
  border: 0;
}

.leaflet-red-marker {
  position: relative;
  display: block;
  width: 26px;
  height: 26px;
  background: #d93025;
  border: 2px solid #fff;
  border-radius: 50% 50% 50% 0;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.35);
  transform: rotate(-45deg);
}

.leaflet-red-marker::after {
  position: absolute;
  top: 7px;
  left: 7px;
  width: 8px;
  height: 8px;
  content: "";
  background: #fff;
  border-radius: 50%;
}

@media (max-width: 767px) {
  .google-map-shell {
    height: 430px;
  }

  .google-style-map .leaflet-control-layers label {
    min-width: 74px;
    padding: 8px 9px;
  }
}
</style>
